<div class="relative">

  <!-- Profile button -->
  <button
    #triggerBtn
    type="button"
    class="flex items-center justify-center w-10 h-10 rounded-full bg-dark-raised text-dark-text-primary text-sm font-semibold hover:ring-2 hover:ring-dark-accent focus:outline-none focus:ring-2 focus:ring-dark-accent transition-all"
    aria-label="Profile menu"
    aria-haspopup="menu"
    [attr.aria-expanded]="open()"
    (click)="toggle()"
  >
    {{ initial() }}
  </button>

  <!-- Popup menu -->
  @if (open()) {
    <div
      class="absolute bottom-12 left-0 w-40 bg-dark-raised border border-dark-border rounded-lg shadow-lg py-1 z-50"
      role="menu"
      aria-label="{{ 'nav.profileMenuLabel' | transloco }}"
      (keydown)="onMenuKeyDown($event)"
    >
      <a
        routerLink="/settings"
        class="flex items-center px-4 py-2 text-sm text-dark-text-secondary hover:text-dark-text-primary hover:bg-dark-surface transition-colors"
        role="menuitem"
        (click)="close()"
      >
        {{ 'nav.settings' | transloco }}
      </a>
      <button
        type="button"
        class="flex w-full items-center px-4 py-2 text-sm text-dark-text-secondary hover:text-dark-text-primary hover:bg-dark-surface transition-colors"
        role="menuitem"
        (click)="onSignOut()"
      >
        {{ 'auth.signOut' | transloco }}
      </button>
    </div>
  }

</div>
